var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCirclePattern(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 205,
    width: 50
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 5,
    fill: "#c4c4c4",
    opacity: 0.08
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 10,
    r: 5,
    fill: "#c4c4c4",
    opacity: 0.08
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 10,
    r: 5,
    fill: "#c4c4c4",
    opacity: 0.08
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 25,
    r: 5,
    fill: "#c4c4c4",
    opacity: 0.08
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 5,
    fill: "#c4c4c4",
    opacity: 0.08
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 25,
    r: 5,
    fill: "#c4c4c4",
    opacity: 0.08
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 40,
    r: 5,
    fill: "#c4c4c4",
    opacity: 0.08
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 40,
    r: 5,
    fill: "#c4c4c4",
    opacity: 0.08
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 5,
    fill: "#c4c4c4",
    opacity: 0.08
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 55,
    r: 5,
    fill: "#c4c4c4",
    opacity: 0.08
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 55,
    r: 5,
    fill: "#c4c4c4",
    opacity: 0.08
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 55,
    r: 5,
    fill: "#c4c4c4",
    opacity: 0.08
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 70,
    r: 5,
    fill: "#c4c4c4",
    opacity: 0.08
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 70,
    r: 5,
    fill: "#c4c4c4",
    opacity: 0.08
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 70,
    r: 5,
    fill: "#c4c4c4",
    opacity: 0.08
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 85,
    r: 5,
    fill: "#c4c4c4",
    opacity: 0.08
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 85,
    r: 5,
    fill: "#c4c4c4",
    opacity: 0.08
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 85,
    r: 5,
    fill: "#c4c4c4",
    opacity: 0.08
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 100,
    r: 5,
    fill: "#c4c4c4",
    opacity: 0.08
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 100,
    r: 5,
    fill: "#c4c4c4",
    opacity: 0.08
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 100,
    r: 5,
    fill: "#c4c4c4",
    opacity: 0.08
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 115,
    r: 5,
    fill: "#c4c4c4",
    opacity: 0.08
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 115,
    r: 5,
    fill: "#c4c4c4",
    opacity: 0.08
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 115,
    r: 5,
    fill: "#c4c4c4",
    opacity: 0.08
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 130,
    r: 5,
    fill: "#c4c4c4",
    opacity: 0.08
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 130,
    r: 5,
    fill: "#c4c4c4",
    opacity: 0.08
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 130,
    r: 5,
    fill: "#c4c4c4",
    opacity: 0.08
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 145,
    r: 5,
    fill: "#c4c4c4",
    opacity: 0.08
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 145,
    r: 5,
    fill: "#c4c4c4",
    opacity: 0.08
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 145,
    r: 5,
    fill: "#c4c4c4",
    opacity: 0.08
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 160,
    r: 5,
    fill: "#c4c4c4",
    opacity: 0.08
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 160,
    r: 5,
    fill: "#c4c4c4",
    opacity: 0.08
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 160,
    r: 5,
    fill: "#c4c4c4",
    opacity: 0.08
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 175,
    r: 5,
    fill: "#c4c4c4",
    opacity: 0.08
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 175,
    r: 5,
    fill: "#c4c4c4",
    opacity: 0.08
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 175,
    r: 5,
    fill: "#c4c4c4",
    opacity: 0.08
  })));
}
export default SvgCirclePattern;